import type { DataBankViewType } from "./add-source/dataBankViewTypes";

export type SourceNodeType =
  | "folder"
  | "file"
  | "link"
  | "table"
  | "quickNote"
  | "dataRepo"
  | "dataBank";

export interface SourceFolder {
  id: string;
  name: string;
  parentId: string | null;
  type: "folder";
  childrenIds: string[];
}

export interface SourceFile {
  id: string;
  name: string;
  parentId: string | null;
  type: "file" | "link" | "table" | "quickNote" | "dataRepo" | "dataBank";
  extension?: string;
  url?: string;
  s3_key?: string;
  /** Elasticsearch index name from data repo `more.es_index`. */
  es_index?: string;
  /** Connected data bank metadata from `more` (fst/fsd/view). */
  data_bank_fst_key?: string;
  data_bank_fsd_id?: number;
  data_bank_view_type?: DataBankViewType;
  data_bank_election?: string;
  data_bank_map_key?: string;
}

export type SourceNode = SourceFolder | SourceFile;

export function normalizeSourceType(type: string): SourceFile["type"] {
  const t = type?.toLowerCase?.() ?? "file";
  if (t === "es_index") return "dataRepo";
  if (t === "data_repo" || t === "datarepo") return "dataRepo";
  if (t === "data_bank" || t === "databank") return "dataBank";
  if (t === "quick_note" || t === "quicknote") return "quickNote";
  if (["link", "table", "file"].includes(t)) return t as "file" | "link" | "table";
  return "file";
}

export function isFolder(node: SourceNode): node is SourceFolder {
  return node.type === "folder";
}

export function isFile(node: SourceNode): node is SourceFile {
  return node.type !== "folder";
}

export function getFileExtension(node: SourceFile): string {
  if (node.extension) return node.extension;
  const parts = node.name.split(".");
  return parts.length > 1 ? (parts.pop() ?? "file") : "file";
}

export const EDITABLE_SOURCE_TYPES: SourceNodeType[] = [
  "folder",
  "file",
  "link",
  "table",
  "quickNote",
  "dataRepo",
  "dataBank",
];

export function isSourceEditable(node: SourceNode): boolean {
  return EDITABLE_SOURCE_TYPES.includes(node.type);
}
